<template functional>
  <svg
    :class="['thumbemote', 'thumbemote--' + props.face]"
    viewBox="0 0 238 300"
  >
    <g class="thumbemote__hand">
      <path
        class="thumbemote__hand__backfill"
        fill="transparent"
        d="M230.8,158.7c4.3-11.7-0.5-26.4-8.5-34.7c2.9-10.2-0.1-21.9-8.1-30.4c1.6-11.3-2-21.4-9.9-27.3c-8.9-6.7-19-7.7-30-3.1c-5.9,2.5-11.3,6.4-15.7,9.5c-1,0.7-1.9,1.4-2.8,2c-8.9-0.8-16.9,2.1-24.6,4.9c-1.7,0.6-3.4,1.2-5,1.8c-9.1,3.1-15.9,3.7-23.6-2.2c-6.7-5.2-12-12-15.4-19.7c-2.1-4.9-3.8-10.4-5.6-16.2c-2.2-7.1-4.4-14.4-7.6-20.9C66.3,6.4,54.8-0.4,37.9,0.9c-5.4,0.3-10.7,2-15.2,4.8C15.8,9.7,10.8,16.3,8.8,24.1c-3.5,14.4,3.5,25.2,10.7,33.8c2.1,2.5,4.4,5,6.6,7.4c5.2,5.6,10.2,11,13,16.8c3.9,8,5.6,15.4,5.3,21.8c-0.5,9.5-9.7,27.1-15.7,38.8c-1.5,2.9-2.8,5.4-3.8,7.5C-2.4,205.6-2.1,219.6,4.4,294.7c0.3,2.9,2.8,5.1,5.7,5l69,0.1l0.2,0l0.2,0c1.5-0.2,2.8-0.9,3.7-2c0.9-1.1,1.3-2.6,1.2-4c-1.3-11.7-2.4-25.3-0.7-37.5c1.5-11,5.1-19.3,11-25.3c4.6,2.5,9.1,4.3,13.6,5.3c17.6,4,39.5,1.9,55.9-5.2c12-5.3,21-13.1,26.2-22.9c6.6,0.9,14.8,0.3,22.4-1.8c6.6-1.8,12-4.5,15.3-7.6C243.9,183.7,235.3,166.3,230.8,158.7z"
      />

      <path
        class="thumbemote__hand__fill"
        :fill="props.fill"
        d="M11.1,289.1c-0.7-9.5-3.3-18.7-3.9-28.2c-1.7-26.6-2-53.6,9.5-78.6c4.4-9.5,8.2-19.4,13.1-28.7c9.8-18.4,27.1-49.8,17.4-70.1c-9-18.9-34.1-28.4-35-51.7C11.3,8.6,46.6-0.5,60.4,12.9C73.3,25.4,73.5,43,80.2,58.6c6.6,15.3,17.7,33,36.9,30.5c7.2-0.9,15.2-5.7,22-7.3c7.9-1.8,16.3,0.9,23.1-4.8c12.9-11,26.8-11.9,32.4-10.7c4,0.9,5.5,1.9,10.5,6.5c4.3,3.9,4.9,10.8,4.8,16.5c0,1.6-1.2,5.6-0.6,6.9c0.2,0.6,1.9,1.4,2.5,1.9c1.6,1.6,3,3.4,4.1,5.4c5.2,8.8,3.6,14.2,2.1,23.4c-0.1,0.5,2.6,3.2,3,3.8c2.4,3.6,4.3,7.6,5.8,11.7c1.6,4.3,2.5,8.6,1.3,13.1c-0.3,1.1-1.4,2.7-1.4,3.8c0,1.2,3.2,6.6,3.8,8.4c2.9,9.3,3,18.9-3.6,26.4c-8.6,9.8-26.2,9.4-38.1,9c-0.8,0-6.6,6.8-7.6,7.9c-5.1,5.9-17.1,14.5-24.8,16.7c-13.9,3.9-21.2,6.3-35.8,5c-6.3-0.6-13.1-3.4-19.2-5.1c-0.9-0.2-6.8-2.7-7.1-2.6c-1.2,0.2-9.2,11.2-10.1,12.8c-6.6,11.9-8.3,26-7.5,39.5c0.2,2.8,3.2,18.3,2.7,19.5c-0.1,0.3-7.4,0.9-8.4,1.2c-11.9,2.7-24.2,3-36.3,0.9c-8.6-1.6-16.9-4.9-24.3-9.5"
      />

      <g class="thumbemote__hand__outline">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M82.57,169.93c-0.76,0.29-1.14,1.14-0.85,1.9c0.28,0.75,1.11,1.13,1.86,0.86l0,0c19.6-7.22,34.76-24.5,31.75-44.36c-0.12-0.8-0.87-1.36-1.67-1.23c-0.8,0.12-1.36,0.87-1.23,1.67C115.23,147.28,100.84,163.2,82.57,169.93z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M226.32,159.04c5.16-10.78,0.17-26.35-8.59-33.92c4.07-10.13,0.57-22.29-7.73-30.19c1.85-9.34-0.13-19.56-7.98-25.42c-9.08-6.79-18.01-5.99-26.03-2.58c-7.39,3.14-13.96,8.55-19.05,11.94c-10.47-1.48-19.93,3.16-29.33,6.34c-8.84,2.99-17.65,4.59-27.34-2.84c-7.21-5.61-12.92-12.92-16.62-21.28c-4.89-11.14-7.52-25.62-13.13-37C64.66,12.19,55.68,3.56,38.14,4.85c-4.76,0.28-9.37,1.73-13.42,4.23c-5.97,3.53-10.3,9.28-12.06,15.99c-2.9,12.05,2.52,21.48,9.91,30.24c7,8.3,15.8,15.97,20.12,24.97c3.5,7.3,6.11,15.57,5.65,23.75c-0.72,12.7-14.53,36.77-19.94,47.81C2.04,205.58,1.83,218.54,8.42,294.32c0.07,0.81,0.78,1.41,1.59,1.34c0.81-0.07,1.41-0.78,1.34-1.59l0,0c-6.52-74.95-6.38-87.78,19.67-140.94c5.53-11.29,19.5-35.95,20.24-48.94c0.49-8.66-2.22-17.45-5.93-25.18c-4.41-9.21-13.35-17.11-20.52-25.6c-6.78-8.03-11.95-16.6-9.3-27.66c1.58-5.95,5.43-11.04,10.74-14.16c3.66-2.25,7.81-3.55,12.1-3.8c16-1.17,24.17,6.75,29.51,17.6c5.59,11.35,8.2,25.78,13.07,36.89c3.91,8.81,9.93,16.51,17.53,22.43c10.66,8.17,20.34,6.59,30.07,3.29c8.44-2.86,16.91-7.09,26.2-6.41c-4.08,6.96-5.59,14.98-3.15,21.37c1.67,4.37,5.15,8.02,10.95,10.1c-5.38,11.14-3.59,24.05,8.19,29.96c-6.04,9.28-4.63,21.52,3.73,29.9c-4.57,11.08,0.38,22.49,10.94,29.6c-4.64,10.34-13.52,17.52-24.02,22.12c-16.46,7.21-36.88,8.14-51.56,4.84c-9.33-2.1-18.29-7.93-25.47-14.78c-0.58-0.57-1.51-0.57-2.08,0.01s-0.57,1.51,0.01,2.08c0.01,0.01,0.03,0.03,0.04,0.04c2.84,2.71,5.95,5.27,9.25,7.52c-8.76,7.91-13.04,18.82-14.73,30.97c-1.74,12.45-0.77,26.2,0.67,39.19c0.09,0.81,0.82,1.39,1.62,1.3c0.81-0.09,1.39-0.82,1.3-1.62c-1.41-12.75-2.39-26.24-0.68-38.46c1.63-11.71,5.73-22.24,14.38-29.72c4.76,2.93,9.85,5.19,15.04,6.35c15.2,3.42,36.34,2.45,53.38-5.01c11.22-4.92,20.65-12.66,25.58-23.74c6.79,1.6,15.88,0.92,23.64-1.22c5.71-1.57,10.7-3.94,13.6-6.67C238.1,183.67,232.93,169.91,226.32,159.04z M154.33,101.9c-2.33-6.11-0.41-13.88,3.89-20.36c5.02-3.31,11.54-8.77,18.9-11.9c7.12-3.03,15.06-3.8,23.12,2.23c7.09,5.3,8.58,14.67,6.75,23.07l0,0c-3.52,5.99-9.56,9.88-16.04,12.35c-9.85,3.75-20.74,4.23-25.86,3.49c-0.1-0.03-0.19-0.05-0.29-0.06C159.21,109.04,155.85,105.86,154.33,101.9z M165.46,113.77c5.7,0.62,16.63,0.03,26.54-3.75c6.61-2.52,12.74-6.44,16.68-12.27c7.35,7.5,10.2,18.82,5.6,27.88h0.01h-0.01c-3.89,7.75-11.91,12.32-20.02,14.61c-8.13,2.3-16.38,2.33-20.83,0.77C161.78,136.13,160.26,123.98,165.46,113.77z M173.54,144.11c5.01,1.36,13.32,1.27,21.52-1.04c8.55-2.42,16.92-7.26,21.35-15.2c7.65,7.1,11.96,20.98,7.02,30.42c-6.09,8.18-18.78,13.34-29.8,14.8c-7.11,0.95-13.54,0.42-16.91-2.08C169.07,163.51,167.81,152.37,173.54,144.11z M223.36,193.55c-2.62,2.48-7.18,4.55-12.36,5.97c-7.82,2.15-17.07,2.81-23.52,0.84c-9.45-6.15-14.2-16.06-10.49-25.81c4.06,1.87,10.24,2.36,17.01,1.46c11.04-1.47,23.58-6.53,30.46-14.35C230.12,171.26,234.39,183.14,223.36,193.55z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M146.29,95.97c-0.79-0.09-1.51,0.47-1.62,1.26l0,0c-1.12,7.84,1.22,15.78,6.4,21.77c0.56,0.59,1.49,0.62,2.08,0.07c0.56-0.53,0.62-1.4,0.14-1.99c-4.63-5.36-6.71-12.47-5.7-19.48C147.68,96.78,147.1,96.06,146.29,95.97z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M156.26,122.37c-0.74-0.29-1.57,0.05-1.89,0.78c-0.99,2.37-1.19,6.64-0.1,10.85c1.09,4.24,3.46,8.39,7.39,10.57c0.71,0.39,1.6,0.14,2-0.57c0.39-0.71,0.14-1.61-0.57-2c-3.22-1.78-5.07-5.25-5.97-8.73c-0.9-3.49-0.85-7.03-0.03-8.99C157.39,123.53,157.02,122.67,156.26,122.37z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M164.19,151.44c-0.75-0.32-1.61,0.02-1.94,0.76c-2.95,7.01-1.35,15.11,4.05,20.48c0.59,0.56,1.52,0.54,2.08-0.04c0.55-0.58,0.54-1.49-0.02-2.05c-4.53-4.51-5.88-11.31-3.41-17.21C165.28,152.63,164.94,151.77,164.19,151.44z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M170.09,178.83c-0.8-0.16-1.57,0.35-1.74,1.15c-1.57,7.66-0.03,17.02,7.34,21.75c0.68,0.44,1.59,0.24,2.03-0.44s0.24-1.59-0.44-2.03c-6.3-4.04-7.39-12.13-6.05-18.68C171.4,179.77,170.88,178.99,170.09,178.83z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M193.22,75.93c3.51,2.71,5.6,7.75,6.49,12c0.18,0.79,0.97,1.29,1.76,1.11c0.77-0.18,1.26-0.93,1.12-1.71c-1.02-4.89-3.53-10.62-7.57-13.73c-0.64-0.5-1.57-0.38-2.06,0.27S192.58,75.44,193.22,75.93z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M210.08,119.24c0.02,0.81,0.69,1.45,1.5,1.43c0.79-0.02,1.42-0.65,1.43-1.44c0.06-4.87-1.5-9.61-4.44-13.49c-0.5-0.64-1.43-0.75-2.07-0.24s-0.75,1.43-0.24,2.07C208.8,110.93,210.14,115.03,210.08,119.24z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M219.36,149.47c-0.07,0.81,0.53,1.52,1.34,1.59c0.81,0.07,1.52-0.53,1.59-1.34c0-0.01,0-0.02,0-0.03c0.36-4.71-1.65-8.98-3.97-12.95c-0.42-0.7-1.32-0.93-2.02-0.51c-0.69,0.41-0.92,1.29-0.52,1.99C217.8,141.69,219.68,145.37,219.36,149.47z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M223.8,169.78c-0.28-0.76-1.13-1.15-1.89-0.87c-0.75,0.28-1.14,1.1-0.88,1.86c1.49,3.84,1.49,8.11,0,11.95c-0.3,0.76,0.08,1.61,0.83,1.9s1.59-0.07,1.89-0.81C225.52,179.3,225.54,174.29,223.8,169.78z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#582679"
          d="M77.18,54.94c-0.62-0.53-1.54-0.46-2.07,0.16c-0.04,0.05-0.08,0.1-0.11,0.15c-4.47,5.93-12.07,7.64-19.15,6.4c-0.8-0.14-1.56,0.39-1.7,1.2c-0.14,0.8,0.39,1.56,1.2,1.7v-0.01c8.15,1.43,16.86-0.69,22.01-7.53C77.87,56.4,77.8,55.47,77.18,54.94z"
        />
      </g>
    </g>
    <g class="thumbemote__face" v-if="props.face === 'very-upset'">
      <path
        fill="#FFFFFF"
        d="M44.57,55.19L44.57,55.19c-5.35-4.21-6.27-11.96-2.06-17.31s11.96-6.27,17.31-2.06c0.32,0.25,0.62,0.51,0.91,0.79c2.29,2.19,3.65,5.19,3.77,8.36c-2.17-1.72-4.85-2.64-7.62-2.63c-6.8,0.01-12.31,5.52-12.32,12.32C44.56,54.83,44.56,55.01,44.57,55.19L44.57,55.19z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M27.25,23.53c3.55-1.97,8.03-0.69,10,2.87c1.97,3.55,0.69,8.03-2.87,10c-3.55,1.97-8.03,0.69-10-2.87l0,0C22.41,29.98,23.69,25.5,27.25,23.53z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M41.22,14.34c3.55-1.97,8.03-0.68,10,2.87s0.68,8.03-2.87,10s-8.03,0.69-10-2.87C36.38,20.79,37.67,16.31,41.22,14.34z"
      />
      <path
        fill="#4E1F7D"
        d="M56.89,42.34c1.02,0,2.03,0.12,3.01,0.37c-1.74-2.15-4.46-3.53-7.54-3.53c-5.25,0-9.5,4.03-9.5,9c0,1.95,0.66,3.74,1.77,5.22C45.27,47.18,50.51,42.35,56.89,42.34z"
      />
    </g>
    <g class="thumbemote__face" v-if="props.face === 'upset'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M37.34,27.73c1.36-0.76,3.08-0.26,3.84,1.1s0.26,3.08-1.1,3.84c-1.36,0.76-3.08,0.26-3.84-1.1C35.48,30.21,35.98,28.49,37.34,27.73z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M45.78,23.06c1.36-0.76,3.08-0.26,3.84,1.1s0.26,3.08-1.1,3.84s-3.08,0.26-3.84-1.1C43.92,25.53,44.41,23.81,45.78,23.06z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FFFFFF"
        d="M61.73,39.81c-3.06-5.51-9.92-7.65-15.57-4.84c-5.69,2.72-8.25,9.43-5.79,15.24c3.5-1.78,7.05-3.57,10.63-5.31C54.58,43.16,58.18,41.46,61.73,39.81z"
      />
      <path
        fill="#4E1F7D"
        d="M61.73,39.81c-3.06-5.51-9.92-7.65-15.57-4.84c-1.01,0.48-1.92,1.09-2.72,1.8c-1.88,3.09-2.2,7.04-0.5,10.54c0.21,0.44,0.46,0.85,0.72,1.24c2.43-1.22,4.87-2.45,7.33-3.64C54.58,43.16,58.18,41.46,61.73,39.81z"
      />
    </g>
    <g class="thumbemote__face" v-if="props.face === 'neutral'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M32.02,32.12c1.9-1.05,4.28-0.37,5.34,1.53c1.05,1.9,0.37,4.28-1.53,5.34c-1.9,1.06-4.28,0.37-5.34-1.53C29.44,35.56,30.12,33.17,32.02,32.12z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M46.54,24.07c1.9-1.05,4.28-0.37,5.34,1.53c1.05,1.9,0.37,4.28-1.53,5.34c-1.9,1.05-4.28,0.37-5.34-1.53C43.96,27.51,44.64,25.12,46.54,24.07z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FFFFFF"
        d="M61.11,35.3c-0.35-0.6-0.94-1.02-1.62-1.14c-0.74-0.14-1.51-0.01-2.17,0.36L38.15,45.14c-0.67,0.36-1.18,0.95-1.46,1.65c-0.25,0.64-0.21,1.37,0.11,1.98l0.94,1.7c0.35,0.6,0.94,1.02,1.62,1.15c0.74,0.14,1.51,0.01,2.17-0.36L60.7,40.63c0.67-0.36,1.18-0.95,1.46-1.65c0.25-0.64,0.21-1.37-0.11-1.98L61.11,35.3z"
      />
      <path
        fill="#4E1F7D"
        d="M41.54,51.26l19.17-10.63c0.67-0.36,1.18-0.95,1.46-1.65c0.2-0.51,0.21-1.06,0.05-1.57c-0.56,0.04-1.12,0.19-1.64,0.48L39.53,49.55c-0.61,0.34-1.08,0.82-1.43,1.38c0.34,0.35,0.78,0.6,1.27,0.69C40.11,51.76,40.88,51.63,41.54,51.26z"
      />
    </g>
    <g class="thumbemote__face" v-if="props.face === 'happy'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M44.52,19.52c-2.05,0.96-2.94,3.4-1.98,5.45s3.4,2.94,5.45,1.98c2.05-0.96,2.94-3.4,1.98-5.45l0,0C49.01,19.45,46.57,18.56,44.52,19.52z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M32.7,27.42c-2.05,0.96-2.94,3.4-1.98,5.45c0.96,2.05,3.4,2.94,5.45,1.98s2.94-3.4,1.98-5.45l0,0C37.19,27.35,34.75,26.47,32.7,27.42z"
      />
      <ellipse
        transform="matrix(0.8481 -0.5299 0.5299 0.8481 -13.6187 32.571)"
        fill="#FFFFFF"
        cx="49.99"
        cy="40.03"
        rx="10.17"
        ry="6.78"
      />
      <path
        fill="#4E1F7D"
        d="M58.95,39.49c-1.76-1.02-4.17-1.34-6.61-0.69c-4.2,1.12-6.89,4.68-6.02,7.94c0.11,0.41,0.27,0.79,0.47,1.15c2.13-0.01,4.54-0.71,6.79-2.12C56.28,44.1,58.17,41.77,58.95,39.49z"
      />
    </g>
    <g class="thumbemote__face" v-if="props.face === 'very-happy'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#FFFFFF"
        d="M36.07,45.26c4.1,5.86,12.18,7.28,18.04,3.18s7.28-12.17,3.18-18.03c-4.05,1.62-7.9,3.69-11.5,6.15C42.24,39.1,38.98,42.02,36.07,45.26z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M26.96,27.95c1.66-1.25,4.02-0.92,5.27,0.74s0.92,4.02-0.74,5.27c-1.66,1.25-4.02,0.92-5.27-0.74C24.97,31.56,25.3,29.2,26.96,27.95z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4E1F7D"
        d="M44.22,16.22c1.66-1.25,4.02-0.92,5.27,0.74s0.92,4.02-0.74,5.27s-4.02,0.92-5.27-0.74S42.56,17.47,44.22,16.22z"
      />
      <path
        fill="none"
        d="M50.55,45.56c2.34-2.11,5.29-3.12,8.21-3.08c1.49-3.88,1.09-8.42-1.48-12.08c-4.05,1.62-7.9,3.69-11.5,6.15c-3.55,2.54-6.81,5.45-9.72,8.7c2.62,3.74,6.86,5.66,11.1,5.5C47.8,48.83,48.92,47.03,50.55,45.56z"
      />
      <path
        fill="#4E1F7D"
        d="M58.76,42.49c-2.92-0.04-5.87,0.97-8.21,3.08c-1.62,1.46-2.74,3.27-3.38,5.2c2.41-0.09,4.81-0.84,6.93-2.33C56.3,46.91,57.87,44.81,58.76,42.49z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    face: String,
    fill: String,
  },
};
</script>
